import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";

const FarmerSurveyTemplateList = (props) => {
  const { addForm } = props;

  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const getFarmerSurveyTemplateUrl = `/api/farmerSurveyTemplateapproval/?orgId=${localStorage.getItem(
    "orgId"
  )}`;


  const { sendRequest: getFarmerSurveyTemplateData } = useHttp();

  const getData = () => {
    getFarmerSurveyTemplateData(
      {
        url: getFarmerSurveyTemplateUrl,
      },
      (res) => {
        if (res) {
          setData(res.output);
          setAllData(res.output);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const { sendRequest: getFarmerSurveyTemplate } = useHttp();

  const getFarmerSurveyTemplateDetail = () => {
    getFarmerSurveyTemplate(
      {
        url: `/api/farmerSurveyTemplate/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        // console.log("res:", res);
        if (res) {
          setData(res);
          setAllData(res);
        }
      },
      (error) => {
        console.log("Error", error);
      }
    );
  };

  useEffect(() => {
    getFarmerSurveyTemplateDetail();
  }, [getFarmerSurveyTemplate]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  
  const { sendRequest: deleteOperation } = useHttp();
  
  const handleDelete = (e, farmerSurveyTemplateId) => {
    e.preventDefault();

    const data = {
      farmerSurveyTemplateId: farmerSurveyTemplateId,
    };
    // console.log("delete started");
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Farmer Survey Template detail?",
      onOk() {
        deleteOperation(
          {
            url: `/api/farmerSurveyTemplate/`,
            method: "DELETE",
            body: data,
          },
          (data) => {
            if (data.success) {
              // console.log("data:", data);
              toast.success(data.success);
              getFarmerSurveyTemplateDetail();
            }
            
            // if (data.error) {
            //   console.log("error:", error);
            //   toast.error(data.error);
            // }
            
          },
          (error) => {
            console.log("Error", error);
          }
        );
      },
      onCancel() {},
    });
  };
  const handleSearch = (e) => {
   var filtertext = e.target.value.trim().toLowerCase();
    
    var filterdata = allData.filter((item) =>
      item.templateDate.toLowerCase().includes(filtertext) ||
      item.templateName.toLowerCase().includes(filtertext)
  );
  
 setData(filterdata); 
                                
setCurrentPage(1);
};

const [canAdd, setCanAdd] = useState("none");
const [canEdit, setCanEdit] = useState("none");
const [canDelete, setCanDelete] = useState("none");
const [canPdf, setCanPdf] = useState("none");
const [canView, setCanView] = useState("none");
const [serviceId, setServiceId] = useState("none");
const [selectedfarmerSurveyTemplate, setSelectedfarmerSurveyTemplate] = useState(null);
const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        // console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);


  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    // console.log(expense);
    setSelectedfarmerSurveyTemplate(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    // console.log(approvalStatus);

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        farmerSurveyTemplateId:
          selectedfarmerSurveyTemplate && selectedfarmerSurveyTemplate.farmerSurveyTemplateId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: parseInt(localStorage.getItem("orgId")),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    console.log(data);

    updateApprovalStatus(
      {
        url: "/api/farmerSurveyTemplateapproval/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        getFarmerSurveyTemplateDetail();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });

        setApprovalPopupVisible(false);
        setRemark("");
        
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //console.log(data);
    const id = data.farmerSurveyTemplateId;
    getFarmerSurveyTemplate(
      {
        url: `/api/farmerSurveyTemplate/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerSurveyTemplateId=${id}`,
      },
      (res) => {
        console.log("detail view res:", res);
        setSelectedData(res);
      },
      (error) => {
        //console.log("Error", error);
      }
    );

    setIsModalOpen(true);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "400px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Farmer Survey Template{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary my-2 mx-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Survey Questionnaires
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row table-responsive">
                      <table className="table table-bordered text-center ">
                        <thead>
                          <tr>
                            <th>Date </th>
                            <th>Template Name </th>
                            <th>Edit</th>
                            <th>Approval</th>
                            <th>View</th>
                            <th>Status</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.templateDate} </td>
                                <td>{x.templateName} </td>
                                <td>
                                  <button
                                    className="btn"
                                    disabled={x.approved === 1}
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    disabled={x.approved === 1}
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    disabled={x.approved === 1}
                                    onClick={(e) =>
                                      handleDelete(e, x.farmerSurveyTemplateId)
                                    }
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Farmer Survey Template Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>

      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Farmer Survey Template Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Date: {selectedData.templateDate}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Template Name: {selectedData.templateName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">Question List:</p>
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="tableheaderrowview">
                    <th>Sr.No</th>
                    <th>Question</th>
                    <th>Question Type</th>
                    <th>Detail List</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.surveyQuestionList&&
                    selectedData.surveyQuestionList.map((items, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{items.surveyQuestion}</td>
                        <td>{items.questionType}</td>
                        <td>{items.itemList}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>

    </>
  );
};

export default FarmerSurveyTemplateList;
